import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { HttpService } from './http.service';
import { urlLinks } from '../utility/url-links';
import { forkJoin } from 'rxjs';

@Injectable()
export class NomenclatureService {

	private cache: { [key: string]: Observable<any> } = {};

	constructor(private httpService: HttpService) { }

	preloadAll(): Promise<any> {
		return new Promise(resolve => {
			forkJoin([
				this.getInstances(),
				this.getCities(),
				this.getCourts(),
				this.getStatuses(),
				this.getNakazatelnoStatuses(),
				this.getStatusesTask(),
				this.getLawyers(),
				this.getDamageTypes(),
				this.getTraumaTypes()
			]).subscribe(() => {
				resolve(true);
			});
		});
	}

	private getCached(key: string, url: string): Observable<any> {
		if (!this.cache[key]) {
			this.cache[key] = this.httpService.get(url).pipe(
				shareReplay(1)   // важната магия – кешира резултата
			);
		}
		return this.cache[key];
	}

	// 🎯 Оттук нататък всичко става супер чисто

	getDamageTypes(): Observable<any> {
		return this.getCached('damageTypes', urlLinks.rest.nomenclature.damageTypes.list);
	}

	getTraumaTypes(): Observable<any> {
		return this.getCached('traumaTypes', urlLinks.rest.nomenclature.traumaTypes.list);
	}

	getChsi(): Observable<any> {
		return this.getCached('chsi', urlLinks.rest.nomenclature.chsi.list);
	}

	getStatusIzpulnitelno(): Observable<any> {
		return this.getCached('statusIzp', urlLinks.rest.nomenclature.izpulnitelniStatusi.list);
	}

	getInstances(): Observable<any> {
		return this.getCached('instances', urlLinks.rest.nomenclature.instances.list);
	}

	getCities(): Observable<any> {
		return this.getCached('cities', urlLinks.rest.nomenclature.cities.list);
	}

	getCourts(): Observable<any> {
		return this.getCached('courts', urlLinks.rest.nomenclature.sudilishta.list);
	}

	getStatuses(): Observable<any> {
		return this.getCached('statuses', urlLinks.rest.nomenclature.statuses.list);
	}

	getNakazatelnoStatuses(): Observable<any> {
		return this.getCached('nakStat', urlLinks.rest.nomenclature.nakazatelniStatusi.list);
	}

	getPaymentGrounds(): Observable<any> {
		return this.getCached('paymentGrounds', urlLinks.rest.nomenclature.paymentGrounds.list);
	}

	getIncomeGrounds(): Observable<any> {
		return this.getCached('incomeGrounds', urlLinks.rest.nomenclature.incomeGrounds.list);
	}

	getLawyers(): Observable<any> {
		return this.getCached('lawyers', urlLinks.rest.nomenclature.lawyers.list);
	}

	getNdoOtgovornici(): Observable<any> {
		return this.getCached('ndoOtgovornici', urlLinks.rest.cases.nakazatelno.otgovornici);
	}

	getStatusesTask(): Observable<any> {
		return this.getCached('statusesTask', urlLinks.rest.nomenclature.statusesTask.list);
	}

	// Ако някога искаш да нулираш кеша:
	clearCache(): void {
		this.cache = {};
	}
}
